const AirlineCode = [
  // PAKISTAN
  { id: 1, code: "PK", name: "Pakistan International Airlines" },
  { id: 2, code: "PI", name: "Airblue" },
  { id: 3, code: "AP", name: "Askari Aviation" },

  // SAUDI
  { id: 4, code: "SV", name: "Saudi Arabian Airlines" },
  { id: 5, code: "XY", name: "Flynas" },
  { id: 6, code: "FZ", name: "Flyadeal" },

  // NIGERIA
  { id: 7, code: "AR", name: "Arik Air" },
  { id: 8, code: "AI", name: "Air Peace" },
  { id: 9, code: "DN", name: "Dana Air" },

  // UNITED KINGDOM
  { id: 10, code: "BA", name: "British Airways" },
  { id: 11, code: "EZ", name: "easyJet" },
  { id: 12, code: "VS", name: "Virgin Atlantic" },

  // UAEs
  { id: 13, code: "EK", name: "Emirates" },
  { id: 14, code: "FZ", name: "Flydubai" },
  { id: 15, code: "JU", name: "Jazeera Airways" },

  // EGYPT
  { id: 16, code: "MS", name: "EgyptAir" },
  { id: 17, code: "NE", name: "Nile Air" },

  // INDIA
  { id: 18, code: "AI", name: "Air India" },
  { id: 19, code: "6E", name: "IndiGo" },
  { id: 20, code: "UK", name: "Vistara" },

  // BANGLADESH
  { id: 21, code: "BG", name: "Biman Bangladesh Airlines" },
  { id: 22, code: "HS", name: "US-Bangla Airlines" },

  // AMERICA
  { id: 23, code: "AA", name: "American Airlines" },
  { id: 24, code: "DL", name: "Delta Airlines" },
  { id: 25, code: "UA", name: "United Airlines" },

  // GAMBIA
  { id: 26, code: "Q7", name: "Gambia Bird" },

  // TURKEY
  { id: 27, code: "TK", name: "Turkish Airlines" },
  { id: 28, code: "PC", name: "Pegasus Airlines" },

  // QATAR
  { id: 29, code: "QR", name: "Qatar Airways" },

  // JAPAN
  { id: 30, code: "JL", name: "Japan Airlines" },
  { id: 31, code: "NH", name: "All Nippon Airways" },

  // CHINA
  { id: 32, code: "CA", name: "Air China" },
  { id: 33, code: "MU", name: "China Eastern Airlines" },

  // GHANA
  { id: 34, code: "KQ", name: "Kenya Airways" },
  { id: 35, code: "AR", name: "Arik Air" },

  // BELGIUM
  { id: 36, code: "SN", name: "Brussels Airlines" },

  // FRANCE
  { id: 37, code: "AF", name: "Air France" },
  { id: 38, code: "MF", name: "French Bee" },

  // KUWAIT
  { id: 39, code: "KU", name: "Kuwait Airways" },

  { id: 39, code: "SQ", name: "Singapore Airlines" },
  { id: 40, code: "EY", name: "Etihad Airways" },

  { id: 41, code: "AT", name: "Royal Air Maroc" },
  { id: 42, code: "AF", name: "Air France" },
  { id: 43, code: "B6", name: "JetBlue Airline" },

  // Proper Airline Code
  //
  { id: 44, code: "2A", name: "Deutsche Bahn AG" },
  { id: 45, code: "2B", name: "Aerocondor Trans Aereos" },
  { id: 46, code: "2D", name: "Denim Air" },
  { id: 47, code: "2E", name: "Ireland Airways" },
  { id: 48, code: "2F", name: "Frontier Flying Service" },
  { id: 49, code: "2G", name: "Debonair Airways " },
  { id: 50, code: "2H", name: "European Airlines" },
  { id: 51, code: "2J", name: "Air Burkina " },
  { id: 52, code: "2K", name: "Kitty Hawk Airlines Inc " },
  { id: 53, code: "2L", name: "Karlog Air" },
  { id: 54, code: "2M", name: "Moldavian Airlines" },
  { id: 55, code: "2N", name: "Haiti Aviation " },
  { id: 56, code: "2P", name: "Air Philippines Corp" },
  { id: 57, code: "2Q", name: "Millenium Air Corp" },
  { id: 58, code: "2S", name: "Island Express" },
  { id: 59, code: "2T", name: "Canada Three Thousand" },
  { id: 60, code: "2U", name: "Western Pacific Air" },
  { id: 61, code: "2V", name: "Amtrak" },
  { id: 62, code: "2W", name: "Pacific Midland Airlines" },
  { id: 63, code: "2Y", name: "Helenair Corporation Ltd" },
  { id: 64, code: "2Z", name: "Changan Airlines " },
  { id: 65, code: "3A", name: "Mafira Air" },
  { id: 66, code: "3B", name: "Avior" },
  { id: 67, code: "3C", name: "Corporate Express Airline" },
  { id: 68, code: "3D", name: "Palair Macedonian Air" },
  { id: 69, code: "3E", name: "Northwestern Air Lease" },
  { id: 70, code: "3H", name: "Air Inuit Ltd " },
  { id: 71, code: "3J", name: "Air Alliance " },
  { id: 72, code: "3K", name: "Tatonduk Flying Service" },
  { id: 73, code: "3M", name: "Gulfstream International" },
  { id: 74, code: "3N", name: "Air Urga" },
  { id: 75, code: "3P", name: "Georgian Airlines " },
  { id: 76, code: "3Q", name: "China Yunnan Airlines" },
  { id: 77, code: "3R", name: "Avia Air Nv" },
  { id: 78, code: "3S", name: "Shuswap Air " },
  { id: 79, code: "3T", name: "Turan Air Airline Company" },
  { id: 80, code: "3U", name: "Sichuan Airlines" },
  { id: 81, code: "3W", name: "Nanjing Airlines " },
  { id: 82, code: "3X", name: "Japan Air Commuter" },
  { id: 83, code: "3Z", name: "Necon Air" },
  { id: 84, code: "4A", name: "Thunderbird" },
  { id: 85, code: "4B", name: "Olson Air Service" },
  { id: 86, code: "4C", name: "Aires" },
  { id: 87, code: "4D", name: "Air Sinai " },
  { id: 88, code: "4E", name: "Tanana Air Service" },
  { id: 89, code: "4F", name: "Air City " },
  { id: 90, code: "4G", name: "Shenzhen Airlines" },

  // 2ND PAGE START
  { id: 91, code: "4J", name: "Love Air" },
  { id: 92, code: "4K", name: "Kenn Borek Air " },
  { id: 93, code: "4M", name: "Minskavia " },
  { id: 94, code: "4N", name: "Air North " },
  { id: 95, code: "4P", name: "Transportes aereos" },
  { id: 96, code: "4Q", name: "Trans North Aviation Ltd " },
  { id: 97, code: "4S", name: "East West Airline" },
  { id: 98, code: "4T", name: "Russian Airlines " },
  { id: 99, code: "4U", name: "Dorado Air SA " },
  { id: 100, code: "4V", name: "Voyageur Airways " },
  { id: 101, code: "4W", name: "Warbelows Air Ventures" },
  { id: 102, code: "4X", name: "F'airlines B.V. " },
  { id: 103, code: "4Y", name: "Yute Air Alaska" },
  { id: 104, code: "4Z", name: "South African Airlink " },
  { id: 105, code: "5A", name: "Alpine Aviation " },
  { id: 106, code: "5B", name: "Tie Aviation " },
  { id: 107, code: "5C", name: "Conquest Airlines" },
  { id: 108, code: "5D", name: "Air Company Donbass Airline" },
  { id: 109, code: "5E", name: "Base Regional Airlines " },
  { id: 110, code: "5F", name: "Bonaire Airways " },
  { id: 111, code: "5H", name: "Heli Trans " },
  { id: 112, code: "5J", name: "Cebu Pacific Air " },
  { id: 113, code: "5K", name: "State Air Company Odessa" },
  { id: 114, code: "5L", name: "Aerosur" },
  { id: 115, code: "5M", name: "Joint Stock Company Siat" },
  { id: 116, code: "5N", name: "Aerotour Dominicano Airline" },
  { id: 117, code: "5P", name: "Ptarmigan Airways " },
  { id: 118, code: "5Q", name: "Skaergaardsflyget" },
  { id: 119, code: "5R", name: "Aero Service" },
  { id: 120, code: "5T", name: "Airlink Airline Ltd" },
  { id: 121, code: "5U", name: "Lineas Aereas del Estado " },
  { id: 122, code: "5V", name: "Vistajet" },
  { id: 123, code: "5W", name: "Executive Express Ltd" },
  { id: 124, code: "5Y", name: "Isles Of Scilly Skybus " },
  { id: 125, code: "5Z", name: "Gonini Air Servic " },
  { id: 126, code: "6A", name: "Aviacsa" },
  { id: 127, code: "6B", name: "Baxter Aviation" },
  { id: 128, code: "6C", name: "Cape Smythe Air Service" },
  { id: 129, code: "6D", name: "Alaska Island Air Inc " },
  { id: 130, code: "6E", name: "Malmo Aviation" },
  { id: 131, code: "6F", name: "Laker Airways Inc " },
  { id: 132, code: "6G", name: "Las Vegas Airlines" },
  { id: 133, code: "6J", name: "Southeast European Air" },
  { id: 134, code: "6K", name: "Korsar" },
  { id: 135, code: "6L", name: "Aklak Inc " },
  { id: 136, code: "6M", name: "Maverick Airways Corp" },
  { id: 137, code: "6N", name: "Trans Travel Airlines" },
  { id: 138, code: "6P", name: "Dac Air" },
  { id: 139, code: "6Q", name: "Slovak Airlines" },
  { id: 140, code: "6R", name: "Air Affaires Afrique" },
  { id: 141, code: "6S", name: "Proteus Helicopters" },

  // 3RD PAGE
  { id: 142, code: "6T", name: "Air Mandalay Ltd" },
  { id: 143, code: "6U", name: "Air Ukraine" },
  { id: 144, code: "6V", name: "Air Vegas" },
  { id: 145, code: "6W", name: "Wilderness Airlines" },
  { id: 146, code: "6Y", name: "Nica" },
  { id: 147, code: "7A", name: "Haines Airways" },
  { id: 148, code: "7B", name: "Krasnoyarsk Airlines " },
  { id: 149, code: "7C", name: "Columbia Pacific Airline " },
  { id: 150, code: "7E", name: "Aeroline Gmbh" },
  { id: 151, code: "7F", name: "First Air" },
  { id: 152, code: "7G", name: "Bellair Inc " },
  { id: 153, code: "7H", name: "Era Aviation" },
  { id: 154, code: "7I", name: "Imperial Air" },
  { id: 155, code: "7J", name: "State Air Company Tajikistan" },
  { id: 156, code: "7K", name: "Larrys Flying Service" },
  { id: 157, code: "7L", name: "Air Bristol Dba Ab Airline" },
  { id: 158, code: "7M", name: "Tyumen Airlines" },
  { id: 159, code: "7N", name: "Air Manitoba" },
  { id: 160, code: "7P", name: "Apa International Air" },
  { id: 161, code: "7Q", name: "Shorouk Air" },
  { id: 162, code: "7R", name: "Redwing Airways" },
  { id: 163, code: "7S", name: "Arctic Transportation" },
  { id: 164, code: "7T", name: "Trans Cote" },
  { id: 165, code: "7U", name: "Avianergo" },
  { id: 166, code: "7V", name: "Austin Express" },
  { id: 167, code: "7W", name: "Air Sask Aviation" },
  { id: 168, code: "7X", name: "Aea International Pte" },
  { id: 169, code: "7Y", name: "West Isle Air" },
  { id: 170, code: "7Z", name: "L.B.Limited" },
  { id: 171, code: "8A", name: "Arctic Air As" },
  { id: 172, code: "8C", name: "Shanxi Airlines" },
  { id: 173, code: "8D", name: "Volare Airlines" },
  { id: 174, code: "8E", name: "Bering Air" },
  { id: 175, code: "8F", name: "Hanair Haiti Ntl Air" },
  { id: 176, code: "8H", name: "Air South West" },
  { id: 177, code: "8J", name: "Jetall" },
  { id: 178, code: "8K", name: "Air Ostrava Ltd" },
  { id: 179, code: "8L", name: "Grand International Airway" },
  { id: 180, code: "8M", name: "Maxair" },
  { id: 181, code: "8N", name: "Flagship Airlines" },
  { id: 182, code: "8O", name: "West Coast Air" },
  { id: 183, code: "8P", name: "Pacific Coastal Airlines" },
  { id: 184, code: "8Q", name: "Baker Aviation" },
  { id: 185, code: "8R", name: "Rock Air" },
  { id: 186, code: "8S", name: "Salair Inc" },
  { id: 187, code: "8T", name: "Air Tindi Ltd" },
  { id: 188, code: "8U", name: "Dolphin Express Airlines" },
  { id: 189, code: "8V", name: "Wright Air Services" },
  { id: 190, code: "8Y", name: "Ecuato Guineana De Aviac" },
  { id: 191, code: "9A", name: "Air Atlantic" },
  { id: 192, code: "9C", name: "Gill Aviation Ltd" },

  // 4th Page
  { id: 193, code: "9E", name: "Express Airlines" },
  { id: 194, code: "9F", name: "Air Sial" },
  { id: 195, code: "9G", name: "Caribbean Air" },
  { id: 196, code: "9J", name: "Pacific Island Aviation" },
  { id: 197, code: "9K", name: "Cape Air" },
  { id: 198, code: "9L", name: "Colgan Air" },
  { id: 199, code: "9M", name: "Central Mountain Air" },
  { id: 200, code: "9N", name: "Trans State Airlines" },
  { id: 201, code: "9P", name: "Fly Jinnah" },
  { id: 202, code: "9R", name: "Air Kilroe Limited" },
  { id: 203, code: "9T", name: "Athabaska Airways" },

  { id: 204, code: "9U", name: "Air Moldova" },
  { id: 205, code: "9V", name: "VIP Air" },
  { id: 206, code: "9W", name: "Jet Airways Ltd" },
  { id: 207, code: "9Z", name: "Tasawi Air Services Ltd" },
  { id: 208, code: "9Y", name: "Air Kazakstan" },
  { id: 209, code: "A2", name: "Intersomal" },
  { id: 210, code: "A4", name: "Southern Winds" },
  { id: 211, code: "A5", name: "Air East Limited" },
  { id: 212, code: "A6", name: "Air Alps Aviation" },
  { id: 213, code: "A7", name: "Astanair" },
  { id: 214, code: "A8", name: "Aerolineas Paraguayas" },

  { id: 215, code: "A9", name: "Aircompany Airzena" },
  { id: 216, code: "AA", name: "American Airlines" },
  { id: 217, code: "AB", name: "Air Berlin" },
  { id: 218, code: "AC", name: "Air Canada" },
  { id: 219, code: "AD", name: "Aspen Mountain Air" },
  { id: 220, code: "AE", name: "Mandarin Airlines" },
  { id: 221, code: "AF", name: "Air France" },
  { id: 222, code: "AG", name: "Provincial Airlines" },
  { id: 223, code: "AH", name: "Air Algerie" },
  { id: 224, code: "AI", name: "Air India" },
  { id: 225, code: "AJ", name: "Air Belgium" },

  { id: 226, code: "AK", name: "Air Asia" },
  { id: 227, code: "AL", name: "Astral aviation" },
  { id: 228, code: "AM", name: "Aeromexico" },
  { id: 229, code: "AN", name: "Ansett" },
  { id: 230, code: "AO", name: "Aviaco" },
  { id: 231, code: "AP", name: "Air One" },
  { id: 232, code: "AQ", name: "Aloha Airlines" },
  { id: 233, code: "AR", name: "Aerolineas Argentinas" },
  { id: 234, code: "AS", name: "Alaska Airlines" },
  { id: 235, code: "AT", name: "Royal Air Maroc" },
  { id: 236, code: "AU", name: "Austral Lineas Aereas" },
  { id: 237, code: "AV", name: "Avianca" },
  { id: 238, code: "AW", name: "P.T. Dirgantara Air Service" },
  { id: 239, code: "AX", name: "Binter Mediterraneo" },
  { id: 240, code: "AY", name: "Finnair" },
  { id: 241, code: "AZ", name: "Alitalia" },
  { id: 242, code: "B2", name: "Belavia" },
  { id: 243, code: "B3", name: "Bellview Airlines Ltd" },

  // 5th Page

  { id: 244, code: "B4", name: "Bhoja Airlines Ltd" },
{ id: 245, code: "NH", name: "All Nippon Airways" },
{ id: 246, code: "B6", name: "Top Air Havacilik Sanayi" },
{ id: 247, code: "Y2", name: "Alliance" },
{ id: 248, code: "B7", name: "Uni Airways Corp" },
{ id: 249, code: "CD", name: "Alliance Air" },
{ id: 250, code: "B8", name: "Italair" },
{ id: 251, code: "EO", name: "Alliance Airlines" },
{ id: 252, code: "B9", name: "Caribbean Airlines Inc" },
{ id: 253, code: "AQ", name: "Aloha Airlines" },
{ id: 254, code: "BA", name: "British Airways" },
{ id: 255, code: "WP", name: "Aloha Islandair" },
{ id: 256, code: "BB", name: "Seaborne Aviation Inc" },
{ id: 257, code: "E8", name: "Alpi Eagles Spa" },
{ id: 258, code: "BC", name: "Air Jet" },
{ id: 259, code: "5A", name: "Alpine Aviation" },
{ id: 260, code: "BD", name: "British Midland Airways" },
{ id: 261, code: "HP", name: "America West Airlines" },
{ id: 262, code: "SA", name: "Centennial Airlines" },
{ id: 263, code: "BE", name: "Markair" },
{ id: 264, code: "BF", name: "American Trans Air" },
{ id: 265, code: "BG", name: "Biman Bangladesh Airline" },
{ id: 266, code: "2V", name: "Amtrak" },
{ id: 267, code: "BH", name: "Transtate Airlines" },
{ id: 268, code: "C3", name: "Angola Air Charter" },
{ id: 269, code: "BI", name: "Royal Brunei" },
{ id: 270, code: "BJ", name: "Aviation Commercial" },
{ id: 271, code: "BK", name: "Paradise Island" },
{ id: 272, code: "BL", name: "Pacific Airlines" },
{ id: 273, code: "BM", name: "Air Sicilia" },
{ id: 274, code: "BN", name: "Landair Intl Airlines" },
{ id: 275, code: "BO", name: "Bouraq Airlines" },
{ id: 276, code: "BP", name: "Air Botswana Corp" },
{ id: 277, code: "Y5", name: "Arax Airways" },
{ id: 278, code: "BQ", name: "Virgin Express" },
{ id: 279, code: "F5", name: "Archana Airways Ltd" },
{ id: 280, code: "BR", name: "Eva Airways Corp" },
{ id: 281, code: "BS", name: "British International" },
{ id: 282, code: "BT", name: "Air Baltic Corp" },
{ id: 283, code: "BU", name: "Braathens" },
{ id: 284, code: "BV", name: "Sun Air" },
{ id: 285, code: "BW", name: "Bwia International" },
{ id: 286, code: "BX", name: "Coast Air" },
{ id: 287, code: "BY", name: "Britannia Airways" },
{ id: 288, code: "BZ", name: "Keystone Air Service" },
{ id: 289, code: "C2", name: "Air Caribbean Ltd" },
{ id: 290, code: "C3", name: "Angola Air Charter" },
{ id: 291, code: "C4", name: "Airlines Of Carriacou" },
{ id: 292, code: "C5", name: "Cretan Airlines SA" },
{ id: 293, code: "C6", name: "Bright Air" },
{ id: 294, code: "C8", name: "Chicago Express Airlines" },
{ id: 295, code: "C9", name: "Co Aéronautique Européen" },
{ id: 296, code: "CA", name: "Air China International" },
{ id: 297, code: "CB", name: "Suckling Airways" },
{ id: 298, code: "CC", name: "Macair Airlines" },
{ id: 299, code: "CD", name: "Alliance Air" },
{ id: 300, code: "CE", name: "Nationwide Air" },
{ id: 301, code: "CF", name: "Faucett" },
{ id: 302, code: "CG", name: "Milne Bay Air Pty" },
{ id: 303, code: "CH", name: "Bemidji Airlines" },
{ id: 304, code: "CI", name: "China Airlines" },
{ id: 305, code: "CJ", name: "China Northern Airlines" },
{ id: 306, code: "CL", name: "Lufthansa Citylin" },
{ id: 307, code: "CM", name: "Copa Companía Panamena" },
{ id: 308, code: "CN", name: "Island Nationair" },



// 6th Page
{ id: 309, code: "CO", name: "Continental Airlines" },
{ id: 310, code: "OC", name: "Aviacion del Noroeste SA" },
{ id: 311, code: "CP", name: "Canadian Airlines" },
{ id: 312, code: "AO", name: "Aviaco" },
{ id: 313, code: "CQ", name: "Air Alpha" },
{ id: 314, code: "T5", name: "Aviacompany Turkmenistan" },
{ id: 315, code: "CS", name: "Continental Micro" },
{ id: 316, code: "6A", name: "Aviacsa" },
{ id: 317, code: "CU", name: "Cubana de Aviación" },
{ id: 318, code: "CV", name: "Air Chathams" },
{ id: 319, code: "7U", name: "Avianergo" },
{ id: 320, code: "CW", name: "Air Marshall Islands Inc" },
{ id: 321, code: "J5", name: "Aviaprima Airlines" },
{ id: 322, code: "CX", name: "Cathay Pacific" },
{ id: 323, code: "GU", name: "Aviateca" },
{ id: 324, code: "CY", name: "Cyprus Airways" },
{ id: 325, code: "CZ", name: "China Southern Airlines" },
{ id: 326, code: "Q6", name: "Aviation Mineralnye Vody" },
{ id: 327, code: "D2", name: "Skyline Nepc Ltd" },
{ id: 328, code: "D3", name: "Daallo Airlines" },
{ id: 329, code: "DF", name: "Aviosarda" },
{ id: 330, code: "D4", name: "Aries del Sur" },
{ id: 331, code: "D5", name: "Nepc Airlines" },
{ id: 332, code: "D6", name: "Inter Air" },
{ id: 333, code: "D7", name: "Air Asia X" },
{ id: 334, code: "D8", name: "Diamond Sakha Airlines" },
{ id: 335, code: "D9", name: "Joint Stock Aviation Co" },
{ id: 336, code: "DA", name: "Air Georgia" },
{ id: 337, code: "DB", name: "Brit Air" },
{ id: 338, code: "DC", name: "Golden Air Flyg Ab" },
{ id: 339, code: "DD", name: "Shuttle Air Cargo" },
{ id: 340, code: "DE", name: "Condor Flugdienst" },
{ id: 341, code: "DF", name: "Aviosarda" },
{ id: 342, code: "DG", name: "Island Airlines Pty" },
{ id: 343, code: "DH", name: "United Express" },
{ id: 344, code: "DI", name: "Deutsche BA" },
{ id: 345, code: "DJ", name: "Nordic European Airlines" },
{ id: 346, code: "DK", name: "Eastland Air" },
{ id: 347, code: "DL", name: "Delta Air Lines" },
{ id: 348, code: "DM", name: "Maersk Air" },
{ id: 349, code: "DN", name: "Trans Pacific Airlines" },
{ id: 350, code: "DO", name: "Companía Dominicana" },
{ id: 351, code: "DP", name: "Air Two Thousand Ltd" },
{ id: 352, code: "DQ", name: "Coastal Air Transport" },
{ id: 353, code: "DR", name: "Air Link Pty" },
{ id: 354, code: "DS", name: "Air Senegal" },
{ id: 355, code: "DT", name: "Taag" },
{ id: 356, code: "DU", name: "Hemus Air" },
{ id: 357, code: "DV", name: "LUFTTAXI FLUGGESELLSCHAFT" },
{ id: 358, code: "DW", name: "Rottnest Airlines" },
{ id: 359, code: "DX", name: "Danish Air Transport" },
{ id: 360, code: "DY", name: "Air Djibouti" },
{ id: 361, code: "DZ", name: "Transcaraibes Air Intl" },
{ id: 362, code: "E2", name: "Everest Air Ltd" },
{ id: 363, code: "E3", name: "Domodedovo Airlines" },
{ id: 364, code: "E4", name: "Aero Asia International" },
{ id: 365, code: "E5", name: "Samara Airlines" },
{ id: 366, code: "E6", name: "Air Company Elf Air" },
{ id: 367, code: "E7", name: "Downeast Express" },


// 7th Page

{ id: 369, code: "E9", name: "Ajt Air International" },
{ id: 370, code: "BW", name: "Bwia International" },
{ id: 371, code: "EA", name: "Eas Europe Airlines" },
{ id: 372, code: "MO", name: "Calm Air International" },
{ id: 373, code: "EC", name: "Heli Inter Riviera" },
{ id: 374, code: "XE", name: "Cambodia Intl Airlines" },
{ id: 375, code: "ED", name: "CCair" },
{ id: 376, code: "UY", name: "Cameroon Airlines" },
{ id: 377, code: "EF", name: "Far Eastern Air Transport" },
{ id: 378, code: "2T", name: "Canada Three Thousand" },
{ id: 379, code: "EG", name: "Japan Asia Airways" },
{ id: 380, code: "CP", name: "Canadian Airlines" },
{ id: 381, code: "EH", name: "Saeta" },
{ id: 382, code: "EI", name: "AER Lingus Limited" },
{ id: 383, code: "EJ", name: "New England Airlines" },
{ id: 384, code: "EK", name: "Emirates" },
{ id: 385, code: "EL", name: "Air Nippon Co Ltd" },
{ id: 386, code: "EM", name: "Western Airlines" },
{ id: 387, code: "EN", name: "Air Dolomiti Spa" },
{ id: 388, code: "EO", name: "Alliance Airlines" },
{ id: 389, code: "EP", name: "Pelita Air Service" },
{ id: 390, code: "EQ", name: "Tame" },
{ id: 391, code: "ER", name: "Air East" },
{ id: 392, code: "ES", name: "Helicopteros Del Cusco" },
{ id: 393, code: "CX", name: "Cathay Pacific" },
{ id: 394, code: "ET", name: "Ethiopian Airlines" },
{ id: 395, code: "EU", name: "Ecuatoriana De Aviación" },
{ id: 396, code: "EV", name: "Atlantic Southeast Airlines" },
{ id: 397, code: "EW", name: "Eurowings" },
{ id: 398, code: "EX", name: "Aerolineas Santo Domingo" },
{ id: 399, code: "EY", name: "Mayan World Airlines" },
{ id: 400, code: "EZ", name: "Sun Air Of Scandinavia" },
{ id: 401, code: "F2", name: "Southern Independent Air" },
{ id: 402, code: "F3", name: "Flying Enterprise" },
{ id: 403, code: "F4", name: "Eureca SRL" },
{ id: 404, code: "F5", name: "Archana Airways Ltd" },
{ id: 405, code: "F6", name: "China National Aviation" },
{ id: 406, code: "F7", name: "Iron Dragon Fly Air Co" },
{ id: 407, code: "F9", name: "Frontier Airlines" },
{ id: 408, code: "FA", name: "Finnaviation" },
{ id: 409, code: "FB", name: "Guard Air" },
{ id: 410, code: "FC", name: "Thuringia Airlines" },
{ id: 411, code: "FD", name: "Cityflyer Express" },
{ id: 412, code: "FE", name: "Eagle Canyon Airlines" },
{ id: 413, code: "FF", name: "Tower Air Inc" },
{ id: 414, code: "FG", name: "Ariana Afghan Airlines" },
{ id: 415, code: "FH", name: "Futura International" },
{ id: 416, code: "FI", name: "Icelandair" },
{ id: 417, code: "FJ", name: "Air Pacific Ltd" },
{ id: 418, code: "FK", name: "Flamenco Airways" },
{ id: 419, code: "FL", name: "Airtran Airways" },
{ id: 420, code: "FM", name: "Shanghai Airlines" },
{ id: 421, code: "FN", name: "Regional Air Lines" },
{ id: 422, code: "FO", name: "Expedition Airways" },
{ id: 423, code: "FP", name: "Aeroleasing SA" },
{ id: 424, code: "FQ", name: "Air Aruba" },
{ id: 425, code: "FR", name: "Ryanair" },
{ id: 426, code: "FS", name: "Missionary Aviation" },

// 8th Page
{ id: 427, code: "FT", name: "Vancouver Island Air Ltd" },
{ id: 428, code: "V8", name: "Contact Air" },
{ id: 429, code: "FU", name: "Air Littoral" },
{ id: 430, code: "CO", name: "Continental Airlines" },
{ id: 431, code: "FV", name: "F Airlines B V" },
{ id: 432, code: "CS", name: "Continental Micro" },
{ id: 433, code: "FW", name: "Canarias Regional Air" },
{ id: 434, code: "CM", name: "Copa Companía Panamena" },
{ id: 435, code: "FX", name: "Fedex" },
{ id: 436, code: "KN", name: "Coral International Air" },
{ id: 437, code: "FY", name: "Hahnair Friedrichshafen" },
{ id: 438, code: "UH", name: "Corp Airlines Canberra" },
{ id: 439, code: "FZ", name: "Air Facilities" },
{ id: 440, code: "3C", name: "Corporate Express Airline" },
{ id: 441, code: "G2", name: "Color Air" },
{ id: 442, code: "G3", name: "Emerald Airways" },
{ id: 443, code: "G4", name: "Guizhou Airlines" },
{ id: 444, code: "G5", name: "Island Air Ltd" },
{ id: 445, code: "G6", name: "Volga Airlines" },
{ id: 446, code: "G7", name: "Gandalf Airlines Spa" },
{ id: 447, code: "G8", name: "Gujarat Airways Ltd" },
{ id: 448, code: "G9", name: "Air Arabia" },
{ id: 449, code: "GA", name: "Garuda Indonesia" },
{ id: 450, code: "GB", name: "Air Glaciers SA" },
{ id: 451, code: "GC", name: "Lina Congo" },
{ id: 452, code: "GD", name: "Trans Aereos Ejecutivos" },
{ id: 453, code: "GE", name: "Transasia Airways" },
{ id: 454, code: "GF", name: "Gulf Air" },
{ id: 455, code: "GG", name: "Tamair" },
{ id: 456, code: "GH", name: "Ghana Airways" },
{ id: 457, code: "GJ", name: "Eurofly Spa" },
{ id: 458, code: "GK", name: "Go One Airways" },
{ id: 459, code: "GL", name: "Greenlandair" },
{ id: 460, code: "GM", name: "Air Slovakia BWJ" },
{ id: 461, code: "GN", name: "Air Gabon" },
{ id: 462, code: "GO", name: "Air Stord" },
{ id: 463, code: "GP", name: "China General Aviation" },
{ id: 464, code: "GQ", name: "Big Sky Airlines" },
{ id: 465, code: "GR", name: "Aurigny Air Services" },
{ id: 466, code: "GT", name: "GB Airways" },
{ id: 467, code: "GU", name: "Aviateca" },
{ id: 468, code: "GV", name: "Riga Airlines" },
{ id: 469, code: "GW", name: "Air Lines of Kuban" },
{ id: 470, code: "GX", name: "Pacific Airways Corp" },
{ id: 471, code: "GY", name: "Guyana Airways" },
{ id: 472, code: "GZ", name: "Air Rarotonga" },
{ id: 473, code: "H2", name: "City Bird" },
{ id: 474, code: "H3", name: "Harbour Air Ltd" },
{ id: 475, code: "H4", name: "Hainan Airlines" },
{ id: 476, code: "H5", name: "Magadan Airlines" },
{ id: 477, code: "H6", name: "Hageland Aviation" },
{ id: 478, code: "H7", name: "Taquan Air Service Inc" },
{ id: 479, code: "H8", name: "Khabarovsk Aviation" },
{ id: 480, code: "H9", name: "Blade Helicopters" },
{ id: 481, code: "HA", name: "Hawaiian Airlines" },
{ id: 482, code: "HB", name: "Augusta Airways" },
{ id: 483, code: "HC", name: "Naske Air" },
{ id: 484, code: "HD", name: "New York Helicopter Corp" },


// 9th Page 
{ id: 485, code: "HE", name: "Lgw Luftfahrtges Walter" },
{ id: 486, code: "MS", name: "Egyptair" },
{ id: 487, code: "HF", name: "Hapag Lloyd" },
{ id: 488, code: "LY", name: "El Al Israel Airlines" },
{ id: 489, code: "HG", name: "Harbor Airlines" },
{ id: 490, code: "G3", name: "Emerald Airways" },
{ id: 491, code: "HH", name: "Islandsflug" },
{ id: 492, code: "HI", name: "Papillon Airways" },
{ id: 493, code: "EK", name: "Emirates" },
{ id: 494, code: "HJ", name: "Swedeways AB" },
{ id: 495, code: "HK", name: "Swan Airlines" },
{ id: 496, code: "HM", name: "Air Seychelles" },
{ id: 497, code: "OV", name: "Estonian Air" },
{ id: 498, code: "S8", name: "Estonian Aviation" },
{ id: 499, code: "ET", name: "Ethiopian Airlines" },
{ id: 500, code: "RN", name: "Euralair International" },
{ id: 501, code: "F4", name: "Eureca SRL" },
{ id: 502, code: "TH", name: "Euroair" },
{ id: 503, code: "HZ", name: "Euroflight Sweden AB" },
{ id: 504, code: "GJ", name: "Eurofly Spa" },
{ id: 505, code: "Y6", name: "Europe Elite" },
{ id: 506, code: "HV", name: "Transavia airlines" },
{ id: 507, code: "HW", name: "North Wright Air" },
{ id: 508, code: "HY", name: "Uzbekistan Airways" },
{ id: 509, code: "L8", name: "European Airways Ltd" },
{ id: 510, code: "IA", name: "Iraqi Airways" },
{ id: 511, code: "IB", name: "IBERIA" },
{ id: 512, code: "IC", name: "Indian Airlines Ltd" },
{ id: 513, code: "ID", name: "Air Normandie" },
{ id: 514, code: "BR", name: "Eva Airways Corp" },
{ id: 515, code: "IE", name: "Solomon Airlines" },
{ id: 516, code: "IF", name: "Great China Airlines" },
{ id: 517, code: "IG", name: "Meridiana Spa" },
{ id: 518, code: "IH", name: "Falcon Aviation AB" },
{ id: 519, code: "II", name: "Business Air Ltd" },
{ id: 520, code: "IJ", name: "Air Liberté" },
{ id: 521, code: "IK", name: "Lynden Air Cargo" },
{ id: 522, code: "IL", name: "Istanbul Airlines" },
{ id: 523, code: "IM", name: "Carib Express Ltd" },
{ id: 524, code: "IN", name: "Macedonian Airlines" },
{ id: 525, code: "IP", name: "Airlines of Tasmania" },
{ id: 526, code: "IQ", name: "Augsburg Airways" },
{ id: 527, code: "IR", name: "Iran Air" },
{ id: 528, code: "IS", name: "Island Airlines" },
{ id: 529, code: "IT", name: "Air Inter Europe" },
{ id: 530, code: "IU", name: "Air Straubing" },
{ id: 531, code: "IV", name: "Fujian Airlines" },
{ id: 532, code: "IW", name: "AOM French Airlines" },
{ id: 533, code: "IX", name: "Flandre Air" },
{ id: 534, code: "IY", name: "Yemenia" },
{ id: 535, code: "IZ", name: "Arkia Israeli Airlines" },
{ id: 536, code: "J2", name: "Azerbaijan Hava Yollari" },
{ id: 537, code: "J4", name: "Buffalo Airways Ltd" },
{ id: 538, code: "J5", name: "Aviaprima Airlines" },
{ id: 539, code: "J7", name: "Valujet Airlines" },
{ id: 540, code: "J8", name: "Berjaya Air" },
{ id: 541, code: "J9", name: "Jet Aspen" },
{ id: 542, code: "JA", name: "Air Bosna" },


// 10th Page
{ id: 543, code: "JB", name: "Helijet Airways" },
{ id: 544, code: "FH", name: "Futura International" },
{ id: 545, code: "JC", name: "Inter Air Direct" },
{ id: 546, code: "G7", name: "Gandalf Airlines Spa" },
{ id: 547, code: "JD", name: "Japan Air System Company" },
{ id: 548, code: "JE", name: "Manx Airlines" },
{ id: 549, code: "JF", name: "L A B Flying Service" },
{ id: 550, code: "JG", name: "Air Greece" },
{ id: 551, code: "JH", name: "Nordeste Linhas Aereas" },
{ id: 552, code: "JI", name: "Midway Airlines" },
{ id: 553, code: "JJ", name: "TAM Meridional" },
{ id: 554, code: "JK", name: "Spanair" },
{ id: 555, code: "JL", name: "JAL Japan Airlines" },
{ id: 556, code: "JM", name: "Air Jamaica" },
{ id: 557, code: "JN", name: "Rich International Air" },
{ id: 558, code: "JO", name: "Eurosky Airlines" },
{ id: 559, code: "JP", name: "Adria Airways" },
{ id: 560, code: "JQ", name: "Trans Jamaican Airlines" },
{ id: 561, code: "JR", name: "Aero California" },
{ id: 562, code: "JS", name: "Air Koryo" },
{ id: 563, code: "JT", name: "Jaro Intl Airlines" },
{ id: 564, code: "JU", name: "Yugoslav Airlines" },
{ id: 565, code: "JV", name: "Bearskin Airlines" },
{ id: 566, code: "JW", name: "Pacific Eagle Airlines" },
{ id: 567, code: "JX", name: "Nice Hélicoptères" },
{ id: 568, code: "JY", name: "Jersey European" },
{ id: 569, code: "JZ", name: "Skyways Ab" },
{ id: 570, code: "K2", name: "Kyrghyzstan Airlines" },
{ id: 571, code: "K3", name: "Air Company Kraiaero" },
{ id: 572, code: "K4", name: "Kazakhstan Airlines" },
{ id: 573, code: "K6", name: "Appolo Airlines S A" },
{ id: 574, code: "K7", name: "National Air Sakha Aviation" },
{ id: 575, code: "K8", name: "Kaliningrad Airlines" },
{ id: 576, code: "K9", name: "Itapemirim Transportes" },
{ id: 577, code: "KA", name: "Hong Kong Dragon Airline" },
{ id: 578, code: "KB", name: "Druk Air" },
{ id: 579, code: "KC", name: "Australian Commuter Air" },
{ id: 580, code: "KD", name: "Kendell Airlines" },
{ id: 581, code: "KE", name: "Korean Air" },
{ id: 582, code: "KF", name: "Air Botnia" },
{ id: 583, code: "KG", name: "Linea Aerea IAACA" },
{ id: 584, code: "KH", name: "Kyrnair" },
{ id: 585, code: "KJ", name: "British Mediterranean" },
{ id: 586, code: "KK", name: "Tam Regional" },
{ id: 587, code: "KL", name: "KLM" },
{ id: 588, code: "KM", name: "Air Malta" },
{ id: 589, code: "KN", name: "Coral International Air" },
{ id: 590, code: "KO", name: "Alaska Central Express" },
{ id: 591, code: "KP", name: "Kiwi International Air" },
{ id: 592, code: "KQ", name: "Kenya Airways" },
{ id: 593, code: "KR", name: "Kar Air" },
{ id: 594, code: "KS", name: "Penair" },
{ id: 595, code: "KT", name: "Kampuchea Airlines" },


// 11th Page
{ id: 596, code: "KU", name: "Kuwait Airways" },
{ id: 597, code: "IB", name: "IBERIA" },
{ id: 598, code: "KV", name: "State United Venture" },
{ id: 599, code: "FI", name: "Icelandair" },
{ id: 600, code: "KW", name: "Carnival Airlines" },
{ id: 601, code: "LS", name: "Iliamna Air Taxi Inc" },
{ id: 602, code: "KX", name: "Cayman Airways Ltd" },
{ id: 603, code: "KY", name: "Waterwings Airways" },
{ id: 604, code: "VQ", name: "Impulse Airlines Ltd" },
{ id: 605, code: "KZ", name: "Linea Aerea Ejecutivo" },
{ id: 606, code: "L3", name: "Kaiken Lineas Aereas" },
{ id: 607, code: "L4", name: "Atlant Sv" },
{ id: 608, code: "L5", name: "Lufttransport" },
{ id: 609, code: "L6", name: "Air Maldives Ltd" },
{ id: 610, code: "L7", name: "Lviv Airlines" },
{ id: 611, code: "L8", name: "European Airways Ltd" },
{ id: 612, code: "L9", name: "Air Mali SA" },
{ id: 613, code: "LA", name: "Lan Chile" },
{ id: 614, code: "LB", name: "Lloyd Aero Boliviano" },
{ id: 615, code: "LC", name: "Loganair" },
{ id: 616, code: "LE", name: "Helgoland Airlines" },
{ id: 617, code: "LF", name: "Jet Train Corp" },
{ id: 618, code: "LG", name: "Luxair" },
{ id: 619, code: "LH", name: "Lufthansa" },
{ id: 620, code: "LI", name: "Liat Caribbean Airline" },
{ id: 621, code: "LJ", name: "Sierra National Airlines" },
{ id: 622, code: "LK", name: "Fairlines" },
{ id: 623, code: "LL", name: "Lineas Aereas Allegro" },
{ id: 624, code: "LM", name: "Antillean Airlines" },
{ id: 625, code: "LN", name: "Libyan Airlines" },
{ id: 626, code: "LO", name: "LOT Polish Airlines" },
{ id: 627, code: "LP", name: "Lan Peru" },
{ id: 628, code: "LQ", name: "Airpac Airlines" },
{ id: 629, code: "LR", name: "Lacsa Airlines" },
{ id: 630, code: "LS", name: "Iliamna Air Taxi Inc" },
{ id: 631, code: "LT", name: "LTU" },
{ id: 632, code: "LU", name: "Air Atlantic Dominicana" },
{ id: 633, code: "LV", name: "Albanian Airlines Mak" },
{ id: 634, code: "LW", name: "Air Nevada" },
{ id: 635, code: "LX", name: "Crossair" },
{ id: 636, code: "LY", name: "El Al Israel Airlines" },
{ id: 637, code: "LZ", name: "Balkan" },
{ id: 638, code: "M2", name: "Mahfooz Aviation G Ltd" },
{ id: 639, code: "M3", name: "European Air Express" },
{ id: 640, code: "M4", name: "Interimpex Avioimpex" },
{ id: 641, code: "M5", name: "Kenmore Air" },
{ id: 642, code: "M6", name: "Chalair" },
{ id: 643, code: "M8", name: "Moscow Airways" },
{ id: 644, code: "M9", name: "Modiluft Ltd" },
{ id: 645, code: "MA", name: "Malev Hungarian Airlines" },
{ id: 646, code: "MC", name: "Air Mobility Command" },
{ id: 647, code: "MD", name: "Air Madagascar" },
{ id: 648, code: "ME", name: "Middle East Airlines" },
{ id: 649, code: "MF", name: "Xiamen Airlines" },
{ id: 650, code: "MG", name: "Djibouti Airlines" },


// 12th Page

{ id: 651, code: "MH", name: "Malaysia Airlines" },
{ id: 652, code: "KR", name: "Kar Air" },
{ id: 653, code: "MI", name: "Silkair" },
{ id: 654, code: "2L", name: "Karlog Air" },
{ id: 655, code: "MJ", name: "Lapa" },
{ id: 656, code: "K4", name: "Kazakhstan Airlines" },
{ id: 657, code: "MK", name: "Air Mauritius" },
{ id: 658, code: "KD", name: "Kendell Airlines" },
{ id: 659, code: "ML", name: "Aero Costa Rica Acori" },
{ id: 660, code: "MM", name: "Soc Aero de Medellin" },
{ id: 661, code: "MN", name: "Commercial Airways" },
{ id: 662, code: "MO", name: "Calm Air International" },
{ id: 663, code: "MP", name: "Martinair Holland" },
{ id: 664, code: "MQ", name: "Simmons Airlines" },
{ id: 665, code: "MR", name: "Air Mauritanie" },
{ id: 666, code: "MS", name: "Egyptair" },
{ id: 667, code: "MT", name: "Flying Colours Airlines" },
{ id: 668, code: "MU", name: "China Eastern Airlines" },
{ id: 669, code: "MV", name: "Great American Airways" },
{ id: 670, code: "MW", name: "Maya Airways" },
{ id: 671, code: "MX", name: "Mexicana" },
{ id: 672, code: "MY", name: "Euroscot Airways Ltd" },
{ id: 673, code: "MZ", name: "Merpati" },
{ id: 674, code: "N2", name: "Aerolineas Internacional" },
{ id: 675, code: "N4", name: "National Airlines Chile" },
{ id: 676, code: "N5", name: "Sardairline Soc Coop Airline" },
{ id: 677, code: "N6", name: "Aero Continente" },
{ id: 678, code: "N7", name: "National Airlines Inc." },
{ id: 679, code: "N8", name: "Expresso Aero" },
{ id: 680, code: "N9", name: "North Coast Aviation Pty" },
{ id: 681, code: "NA", name: "Executive Airlines" },
{ id: 682, code: "NB", name: "Sterling Airways" },
{ id: 683, code: "NC", name: "National Jet Systems Pty" },
{ id: 684, code: "ND", name: "Airlink Pty Ltd" },
{ id: 685, code: "NE", name: "Knight Air" },
{ id: 686, code: "NF", name: "Air Vanuatu" },
{ id: 687, code: "NG", name: "Lauda Air" },
{ id: 688, code: "NH", name: "All Nippon Airways" },
{ id: 689, code: "NI", name: "Portugalia" },
{ id: 690, code: "NJ", name: "Vanguard Airlines Inc" },
{ id: 691, code: "NK", name: "Spirit Airlines" },
{ id: 692, code: "NL", name: "Shaheen Air" },
{ id: 693, code: "NM", name: "Mount Cook Airline" },
{ id: 694, code: "NN", name: "Cardinal Airlines Ltd" },
{ id: 695, code: "NO", name: "AUS Air" },
{ id: 696, code: "NP", name: "Skytrans" },
{ id: 697, code: "NQ", name: "Orbi Georgian Air" },
{ id: 698, code: "NR", name: "Norontair" },
{ id: 699, code: "NS", name: "Cape York Air" },
{ id: 700, code: "NT", name: "Binter Canarias" },
{ id: 701, code: "NU", name: "Japan Transocean Air Co" },
{ id: 702, code: "NV", name: "Nwt Air" },
{ id: 703, code: "NW", name: "Northwest Airlines" },
{ id: 704, code: "NX", name: "Air Macau Company Ltd" },
{ id: 705, code: "NY", name: "Air Iceland" },


// 13th Page

{ id: 706, code: "NZ", name: "Air New Zealand Ltd" },
{ id: 707, code: "YL", name: "Long Island Airlines Ltd" },
{ id: 708, code: "OA", name: "Olympic Airways" },
{ id: 709, code: "LO", name: "LOT Polish Airlines" },
{ id: 710, code: "OB", name: "Shepparton Airlines" },
{ id: 711, code: "OC", name: "Aviacion del Noroeste SA" },
{ id: 712, code: "OD", name: "Zuliana de Aviaci" },
{ id: 713, code: "OE", name: "Westair Commuter Airline" },
{ id: 714, code: "OF", name: "Trav Aeriens Madagascar" },
{ id: 715, code: "OG", name: "Austrian Airtransport" },
{ id: 716, code: "OH", name: "Comair" },
{ id: 717, code: "OI", name: "Aspiring Air Services" },
{ id: 718, code: "OJ", name: "Air St Barthelemy" },
{ id: 719, code: "OK", name: "Czech Airlines" },
{ id: 720, code: "OL", name: "OLT Ostfriesische Lufttransport" },
{ id: 721, code: "OM", name: "Miat Mongolian Airlines" },
{ id: 722, code: "ON", name: "Air Nauru" },
{ id: 723, code: "OO", name: "Sky West Airlines" },
{ id: 724, code: "OP", name: "Pan Am Air Bridge" },
{ id: 725, code: "OQ", name: "Zambian Express Airways" },
{ id: 726, code: "OR", name: "Crimea Air" },
{ id: 727, code: "OS", name: "Austrian Airlines" },
{ id: 728, code: "OT", name: "Avant Airlines" },
{ id: 729, code: "OU", name: "Croatia Airlines" },
{ id: 730, code: "OV", name: "Estonian Air" },
{ id: 731, code: "OW", name: "OneWorld Alliance" },
{ id: 732, code: "OX", name: "Orient Express Air" },
{ id: 733, code: "OY", name: "African Intercontinental" },
{ id: 734, code: "OZ", name: "Asiana Airlines" },
{ id: 735, code: "P2", name: "Tymen Air Carrier" },
{ id: 736, code: "P3", name: "Air Provence" },
// { id: 737, code: "P4", name: "Aero Lineas Sosa" },
{ id: 738, code: "P5", name: "Aerorepublica" },
{ id: 739, code: "P6", name: "Trans Air" },
{ id: 740, code: "P7", name: "Joint Stock Co East Line" },
{ id: 741, code: "P8", name: "Pantanal Linhas Aereas" },
// { id: 742, code: "PA", name: "Pan American" },
{ id: 743, code: "PB", name: "Air Burundi" },
{ id: 744, code: "PC", name: "Air Fiji Ltd" },
{ id: 745, code: "PD", name: "Pemair" },
{ id: 746, code: "PE", name: "Air Europe Spa" },
{ id: 747, code: "PF", name: "Airsial" },
{ id: 748, code: "PG", name: "Bangkok Airways" },
{ id: 749, code: "PH", name: "Polynesian Ltd" },
{ id: 750, code: "PI", name: "Sunflower Airlines" },
{ id: 751, code: "PJ", name: "Air St Pierre" },
{ id: 752, code: "PK", name: "Pakistan International" },
{ id: 753, code: "PL", name: "Aeroperu" },
{ id: 754, code: "PM", name: "Tropic Air" },
{ id: 755, code: "PN", name: "Ste Nlle Air Martinique" },
{ id: 756, code: "PP", name: "Jet Aviation Business AG" },
{ id: 757, code: "PQ", name: "Skippers Aviation Pty Lt" },
{ id: 758, code: "PR", name: "Philippine Airlines" },

// 14th Page

{ id: 759, code: "PS", name: "Ukraine Intl Airlines" },
{ id: 760, code: "ZR", name: "MUK Air" },
{ id: 761, code: "PT", name: "West Air Sweden" },
{ id: 762, code: "PU", name: "Pluna" },
{ id: 763, code: "UB", name: "Myanmar Airways Intl" },
{ id: 764, code: "PV", name: "Pauknair" },
{ id: 765, code: "3W", name: "Nanjing Airlines" },
{ id: 766, code: "PW", name: "Pine State Airlines" },
{ id: 767, code: "HC", name: "Naske Air" },
{ id: 768, code: "PX", name: "Air Niugini" },
{ id: 769, code: "PY", name: "Surinam Airways" },
{ id: 770, code: "PZ", name: "Tra.Aereos del Mercosur" },
{ id: 771, code: "Q2", name: "Minerva Airlines" },
{ id: 772, code: "Q3", name: "Sandaun Air Services" },
{ id: 773, code: "Q4", name: "Mustique Airways" },
{ id: 774, code: "Q5", name: "Forty Mile Air" },
{ id: 775, code: "Q6", name: "Aviation Mineralnye Vody" },
{ id: 776, code: "Q7", name: "Sobelair" },
{ id: 777, code: "Q8", name: "Donetsk Aviation" },
{ id: 778, code: "Q9", name: "Interbrasil Star S.A." },
{ id: 779, code: "QA", name: "Aerocaribe" },
{ id: 780, code: "QB", name: "Northern Airlines Sanya" },
{ id: 781, code: "QC", name: "Air Zaire" },
{ id: 782, code: "QE", name: "Crossair Europe" },
{ id: 783, code: "QF", name: "Qantas Airways Ltd" },
{ id: 784, code: "QG", name: "Prima Air" },
{ id: 785, code: "QH", name: "Qwestair" },
{ id: 786, code: "QI", name: "Cimber Air" },
{ id: 787, code: "QJ", name: "Jet Airways Inc" },
{ id: 788, code: "QK", name: "Air Nova" },
{ id: 789, code: "QL", name: "Lesotho Airways" },
{ id: 790, code: "QM", name: "Air Malawi Limited" },
{ id: 791, code: "QN", name: "Royal Aviation" },
{ id: 792, code: "QO", name: "Aeromexpress" },
{ id: 793, code: "QP", name: "Air Kenya Aviation" },
{ id: 794, code: "QQ", name: "Reno Air Inc" },
{ id: 795, code: "QR", name: "Qatar Airways" },
{ id: 796, code: "QS", name: "Tatra Air" },
{ id: 797, code: "QT", name: "Sar Avions Taxis" },
{ id: 798, code: "QU", name: "Uganda Airlines" },
{ id: 799, code: "QV", name: "Lao Aviation" },
{ id: 800, code: "QW", name: "Turks and Caicos Airways" },
{ id: 801, code: "QX", name: "Horizon Air" },
{ id: 802, code: "QY", name: "European Air Transport" },
{ id: 803, code: "R2", name: "State Orenburg Avia" },
{ id: 804, code: "R3", name: "Armenian Airlines" },
{ id: 805, code: "R4", name: "Russia" },
{ id: 806, code: "R5", name: "Malta Air Charter" },
{ id: 807, code: "R6", name: "Cypress Airlines" },
{ id: 808, code: "R7", name: "Aeroservicios Carabobo" },
{ id: 809, code: "R8", name: "Reguljair" },
{ id: 810, code: "R9", name: "Air Charter" },
{ id: 811, code: "RA", name: "Royal Nepal Airlines" },
{ id: 812, code: "RB", name: "Syrianair" },
{ id: 813, code: "RC", name: "Atlantic Airways" },


// 15th Page


{ id: 814, code: "RD", name: "Alitalia Team" },
{ id: 815, code: "3D", name: "Palair Macedonian Air" },
{ id: 816, code: "RE", name: "Aeronautica de Cancun" },
{ id: 817, code: "PF", name: "Palestinian Airlines" },
{ id: 818, code: "RF", name: "Ord Air Charter PTY LTD" },
{ id: 819, code: "RG", name: "Varig" },
{ id: 820, code: "RI", name: "P T Mandala Airlines" },
{ id: 821, code: "RJ", name: "Royal Jordanian" },
{ id: 822, code: "RK", name: "Ryan Air" },
{ id: 823, code: "RL", name: "Region Air Carribean Ltd" },
{ id: 824, code: "RM", name: "Air Moldova International" },
{ id: 825, code: "RN", name: "Euralair International" },
{ id: 826, code: "RO", name: "Tarom" },
{ id: 827, code: "RQ", name: "Kam Air" },
{ id: 828, code: "RR", name: "Royal Air Force" },
{ id: 829, code: "RS", name: "Intercont de Aviación" },
{ id: 830, code: "RT", name: "Lincoln Airlines" },
{ id: 831, code: "RU", name: "TCI Skyking Ltd" },
{ id: 832, code: "RV", name: "Reeve Aleutian Airways" },
{ id: 833, code: "RW", name: "Ras Fluggesellschaft MBH" },
{ id: 834, code: "RX", name: "Redwing Airways Inc" },
{ id: 835, code: "RY", name: "Air Rwanda" },
{ id: 836, code: "RZ", name: "Sansa" },
{ id: 837, code: "S2", name: "Sahara India Airlines" },
{ id: 838, code: "S3", name: "Astoria" },
{ id: 839, code: "S4", name: "Spair Air Transport" },
{ id: 840, code: "S5", name: "Virgin Islands Airways" },
{ id: 841, code: "S6", name: "Air St Martin" },
{ id: 842, code: "S7", name: "Siberia Airlines" },
{ id: 843, code: "S8", name: "Estonian Aviation" },
{ id: 844, code: "S9", name: "SAE Swe Aviation Europe" },
{ id: 845, code: "SA", name: "South African Airways" },
{ id: 846, code: "SB", name: "Air Calédonie International" },
{ id: 847, code: "SC", name: "Shandong Airlines" },
{ id: 848, code: "SD", name: "Sudan Airways Co Ltd" },
{ id: 849, code: "SE", name: "Wings of Alaska" },
{ id: 850, code: "SG", name: "Sempati Air" },
{ id: 851, code: "SH", name: "Air Toulouse" },
{ id: 852, code: "SI", name: "Svea Flug" },
{ id: 853, code: "SJ", name: "Southern Air Transport" },
{ id: 854, code: "SK", name: "Scandinavian Airlines" },
{ id: 855, code: "SL", name: "Rio Sul" },
{ id: 856, code: "SM", name: "Sunworld Intl Airlines" },
{ id: 857, code: "SN", name: "Sabena" },
{ id: 858, code: "SO", name: "Swiss World Airways" },
{ id: 859, code: "SP", name: "Sata Air Acores" },
{ id: 860, code: "SQ", name: "Singapore Airlines" },
{ id: 861, code: "SR", name: "Swissair" },
{ id: 862, code: "SS", name: "Corse Air International" },
{ id: 863, code: "ST", name: "Yanda Airlines" },
{ id: 864, code: "SU", name: "Aeroflot Russian" },
{ id: 865, code: "SV", name: "Saudi Arabian Airlines" },
{ id: 866, code: "SW", name: "Air Namibia" },

// 16th Page
{ id: 867, code: "SX", name: "Aeroejecutivo SA de CV" },
{ id: 868, code: "RJ", name: "Royal Jordanian" },
{ id: 869, code: "SY", name: "Sun Country Airlines" },
{ id: 870, code: "RA", name: "Royal Nepal Airlines" },
{ id: 871, code: "SZ", name: "China Southwest Airlines" },
{ id: 872, code: "ZC", name: "Royal Swazi National Air" },
{ id: 873, code: "T2", name: "Taba Transportes Aereos" },
{ id: 874, code: "T3", name: "Eastern Airways Ltd" },
{ id: 875, code: "T4", name: "Transeast Airlines" },
{ id: 876, code: "T5", name: "Aviacompany Turkmenistan" },
{ id: 877, code: "T6", name: "Tavrey Aircompany" },
{ id: 878, code: "T7", name: "Air Trans Ireland Services" },
{ id: 879, code: "T8", name: "Transportes Aereos Neuqu" },
{ id: 880, code: "T9", name: "Master Aviation" },
{ id: 881, code: "TA", name: "Taca Intl Airlines" },
{ id: 882, code: "TB", name: "Shuttle Inc" },
{ id: 883, code: "TC", name: "Air Tanzania Corp" },
{ id: 884, code: "TD", name: "TNT Sava" },
{ id: 885, code: "TE", name: "Lithuanian Airlines" },
{ id: 886, code: "TF", name: "Air Transport Pyrenees" },
{ id: 887, code: "TG", name: "Thai Airways Intl" },
{ id: 888, code: "TH", name: "Euroair" },
{ id: 889, code: "TI", name: "Baltic Intl Airlines" },
{ id: 890, code: "TJ", name: "TAS Airways" },
{ id: 891, code: "TK", name: "Turkish Airlines" },
{ id: 892, code: "TL", name: "Airnorth Regional" },
{ id: 893, code: "TM", name: "LAM Mozambique" },
{ id: 894, code: "TN", name: "Air Tahiti Nui" },
{ id: 895, code: "TP", name: "TAP Air Portugal" },
{ id: 896, code: "TR", name: "Transbrasil" },
{ id: 897, code: "TS", name: "Samoa Aviation" },
{ id: 898, code: "TT", name: "Air Lithuania" },
{ id: 899, code: "TU", name: "Tunis Air" },
{ id: 900, code: "TW", name: "Trans World Airlines Inc" },
{ id: 901, code: "TX", name: "Ste Nlle Air Guadeloupe" },
{ id: 902, code: "TY", name: "Air Caledonie" },
{ id: 903, code: "TZ", name: "American Trans Air" },
{ id: 904, code: "U2", name: "Easyjet Airline Company Ltd" },
{ id: 905, code: "U3", name: "Travelair" },
{ id: 906, code: "U4", name: "Noman" },
{ id: 907, code: "U5", name: "International Business Air" },
{ id: 908, code: "U6", name: "Ural Airlines" },
{ id: 909, code: "U7", name: "United Aviation" },
{ id: 910, code: "U9", name: "Selcon Airlines Ltd" },
{ id: 911, code: "UA", name: "United Airlines" },
{ id: 912, code: "UB", name: "Myanmar Airways Intl" },
{ id: 913, code: "UC", name: "Ladeco Airlines" },
{ id: 914, code: "UD", name: "HEX Air" },
{ id: 915, code: "UE", name: "Transeuropean Airlines" },
{ id: 916, code: "UF", name: "Turkestan Airlines" },
{ id: 917, code: "UG", name: "Tuninter" },
{ id: 918, code: "UH", name: "Corp Airlines Canberra" },
{ id: 919, code: "UI", name: "Alaska Seaplane Service" },
{ id: 920, code: "UJ", name: "Aerosanta Airlines" },

// 17th Page
{ id: 922, code: "YT", name: "Skywest Airlines" },
{ id: 923, code: "UL", name: "Airlanka Ltd" },
{ id: 924, code: "UM", name: "Air Zimbabwe" },
{ id: 925, code: "6Q", name: "Slovak Airlines" },
{ id: 926, code: "UN", name: "Transaero Airlines" },
{ id: 927, code: "Q7", name: "Sobelair" },
{ id: 928, code: "UO", name: "Northern Star Airlines" },
{ id: 929, code: "IE", name: "Solomon Airlines" },
{ id: 930, code: "UP", name: "Bahamasair" },
{ id: 931, code: "UQ", name: "O Connor Mt Gambiers" },
{ id: 932, code: "US", name: "US Airways" },
{ id: 933, code: "SA", name: "South African Airways" },
{ id: 934, code: "YB", name: "South African Express" },
{ id: 935, code: "6J", name: "Southeast European Air" },
{ id: 936, code: "UT", name: "Air Charter Asia" },
{ id: 937, code: "UU", name: "Air Austral" },
{ id: 938, code: "UV", name: "Helicopteros del Sureste" },
{ id: 939, code: "UW", name: "Perimeter Airlines" },
{ id: 940, code: "UX", name: "Air Europa" },
{ id: 941, code: "UY", name: "Cameroon Airlines" },
{ id: 942, code: "UZ", name: "UP Air" },
{ id: 943, code: "V2", name: "Valdresfly AS" },
{ id: 944, code: "V3", name: "Vanair Limited" },
{ id: 945, code: "V4", name: "Venus Airlines" },
{ id: 946, code: "V5", name: "Vnukovo Airlines" },
{ id: 947, code: "V6", name: "Orient Avia" },
{ id: 948, code: "V8", name: "Contact Air" },
{ id: 949, code: "V9", name: "Bashkir Airlines" },
{ id: 950, code: "VA", name: "Viasa Venezolana" },
{ id: 951, code: "VB", name: "Maersk Air Ltd" },
{ id: 952, code: "VC", name: "Servicios Avensa" },
{ id: 953, code: "VE", name: "Avensa" },
{ id: 954, code: "VE", name: "Aerovias Venezolanas" },
{ id: 955, code: "VF", name: "Ajet Airline" },
{ id: 956, code: "VG", name: "VLM Vlaamse" },
{ id: 957, code: "VH", name: "Aeropostal Alas" },
{ id: 958, code: "VI", name: "Vieques Air Link" },
{ id: 959, code: "VJ", name: "Royal Air Cambodge" },
{ id: 960, code: "VK", name: "Air Tungaru" },
{ id: 961, code: "VL", name: "North Vancouver Airlines" },
{ id: 962, code: "VM", name: "Regional Airlines" },
{ id: 963, code: "VN", name: "Vietnam Airlines" },
{ id: 964, code: "VO", name: "Tyrolean Airways" },
{ id: 965, code: "VP", name: "Vaspbrazilian Airlines" },
{ id: 966, code: "VQ", name: "Impulse Airlines Ltd" },
{ id: 967, code: "VR", name: "TACV Cabo Verde Airlines" },
{ id: 968, code: "VS", name: "Virgin Atlantic" },
{ id: 969, code: "VT", name: "Air Tahiti" },
{ id: 970, code: "VU", name: "Air Ivoire" },
{ id: 971, code: "VV", name: "Aerosweet" },
{ id: 972, code: "VW", name: "Aeromar Airlines" },
{ id: 973, code: "VX", name: "Aces" },
{ id: 974, code: "VY", name: "Formosa Airlines Corp." },
{ id: 975, code: "VZ", name: "Airtours Intl Airways" },
{ id: 976, code: "W3", name: "Swiftair SA" },
{ id: 977, code: "W4", name: "Aero Services Executive" },
{ id: 978, code: "W5", name: "Tajikistan International" },

// 18th Page

{ id: 979, code: "W7", name: "Western Pacific Airlines" },
{ id: 980, code: "TJ", name: "TAS Airways" },
{ id: 981, code: "W8", name: "Carribean Winds Airlines" },
{ id: 982, code: "9X", name: "Tasawi Air Services Ltd" },
{ id: 983, code: "W9", name: "Wizz Air" },
{ id: 984, code: "3K", name: "Tatonduk Flying Service" },
{ id: 985, code: "WA", name: "KLM City Hopper" },
{ id: 986, code: "QS", name: "Tatra Air" },
{ id: 987, code: "WB", name: "RwandAir" },
{ id: 988, code: "T6", name: "Tavrey Aircompany" },
{ id: 989, code: "WC", name: "Islena de Inversiones SA" },
{ id: 990, code: "Z4", name: "Tayfunair Inc" },
{ id: 991, code: "WD", name: "Halisa Air" },
{ id: 992, code: "RU", name: "TCI Skyking Ltd" },
{ id: 993, code: "WE", name: "Rheintalflug Seewald" },
{ id: 994, code: "ZJ", name: "Teddy Air" },
{ id: 995, code: "WF", name: "Wideroe" },
{ id: 996, code: "TG", name: "Thai Airways Intl" },
{ id: 997, code: "WG", name: "Wasaya Airways Ltd" },
{ id: 998, code: "4A", name: "Thunderbird" },
{ id: 999, code: "WH", name: "China Northwest Airlines" },
{ id: 1000, code: "FC", name: "Thuringia Airlines" },
{ id: 1001, code: "WI", name: "U Land Airlines" },
{ id: 1002, code: "5B", name: "Tie Aviation" },
{ id: 1003, code: "WJ", name: "Labrador Airways Ltd" },
{ id: 1004, code: "TD", name: "TNT Sava" },
{ id: 1005, code: "WL", name: "Aeroperlas" },
{ id: 1006, code: "B6", name: "Top Air Havacilik Sanayi" },
{ id: 1007, code: "WM", name: "Windward Island Airways" },
{ id: 1008, code: "FF", name: "Tower Air Inc" },
{ id: 1009, code: "WN", name: "Southwest Airlines Texas" },
{ id: 1010, code: "WO", name: "World Airways" },
{ id: 1011, code: "YZ", name: "Trans Aer Guine Bissau" },
{ id: 1012, code: "WP", name: "Aloha Islandair" },
{ id: 1013, code: "WQ", name: "Romavia" },
{ id: 1014, code: "WR", name: "Royal Tongan Airlines" },
{ id: 1015, code: "WS", name: "Air Caraibes" },
{ id: 1016, code: "WT", name: "Nigeria Airways" },
{ id: 1017, code: "WV", name: "Air South Airlines Inc" },
{ id: 1018, code: "WW", name: "Whyalla Airlines" },
{ id: 1019, code: "WX", name: "Cityjet" },
{ id: 1020, code: "WY", name: "Oman Air" },
{ id: 1021, code: "WZ", name: "Acvilla Air" },
{ id: 1022, code: "X2", name: "China Xinhua Airlines" },
{ id: 1023, code: "X3", name: "Baikal Airlines" },
{ id: 1024, code: "X4", name: "Haiti Trans Air" },
{ id: 1025, code: "X5", name: "Cronus Airlines" },
{ id: 1026, code: "X6", name: "Khors Aircompany Ltd" },
{ id: 1027, code: "X7", name: "Joint Stock Company" },
{ id: 1028, code: "X8", name: "Aerovias Dap SA" },
{ id: 1029, code: "XC", name: "K D Air Corporation" },
{ id: 1030, code: "XE", name: "Cambodia Intl Airlines" },
{ id: 1031, code: "XG", name: "Regional Lineas Aereas" },
{ id: 1032, code: "XJ", name: "Mesaba Airlines" },
{ id: 1033, code: "XK", name: "Corse Méditerranée" },
{ id: 1034, code: "XL", name: "Country Connection Airline" },
{ id: 1035, code: "XM", name: "Alitalia Express" },
{ id: 1036, code: "XO", name: "Xinjiang Airlines" },
{ id: 1037, code: "XP", name: "Casino Express Airlines" },
{ id: 1038, code: "XQ", name: "Action Airlines" },
{ id: 1039, code: "XT", name: "KLM Exel" },
{ id: 1040, code: "XU", name: "Link Airways" },
{ id: 1041, code: "XV", name: "Air Express" },
{ id: 1042, code: "XZ", name: "Eastair" },
{ id: 1043, code: "Y2", name: "Alliance" },
{ id: 1044, code: "Y3", name: "Asia Service Airlines" },
{ id: 1045, code: "Y4", name: "Eagle Aviation Ltd" },

// 19th Page
{ id: 1046, code: "Y5", name: "Arax Airways" },
{ id: 1047, code: "QU", name: "Uganda Airlines" },
{ id: 1048, code: "Y6", name: "Europe Elite" },
{ id: 1049, code: "PS", name: "Ukraine Intl Airlines" },
{ id: 1050, code: "Y7", name: "Iran Asseman Airlines" },
{ id: 1051, code: "B7", name: "Uni Airways Corp" },
{ id: 1052, code: "Y8", name: "Passadero Trans Aereos" },
{ id: 1053, code: "UA", name: "United Airlines" },
{ id: 1054, code: "Y9", name: "Trans Air Congo" },
{ id: 1055, code: "U7", name: "United Aviation" },
{ id: 1056, code: "YA", name: "Nego Airline One" },
{ id: 1057, code: "DH", name: "United Express" },
{ id: 1058, code: "YB", name: "South African Express" },
{ id: 1059, code: "UZ", name: "UP Air" },
{ id: 1060, code: "YC", name: "Flight West Airlines" },
{ id: 1061, code: "U6", name: "Ural Airlines" },
{ id: 1062, code: "YD", name: "Gomelavia" },
{ id: 1063, code: "US", name: "US Airways" },
{ id: 1064, code: "YE", name: "Emerald European Airways" },
{ id: 1065, code: "HY", name: "Uzbekistan Airways" },
{ id: 1066, code: "YH", name: "Air Nunavut" },
{ id: 1067, code: "V2", name: "Valdresfly AS" },
{ id: 1068, code: "YI", name: "Air Sunshine" },
{ id: 1069, code: "J7", name: "Valujet Airlines" },
{ id: 1070, code: "YJ", name: "National Airlines" },
{ id: 1071, code: "V3", name: "Vanair Limited" },
{ id: 1072, code: "YK", name: "International Aviation" },
{ id: 1073, code: "FT", name: "Vancouver Island Air Ltd" },
{ id: 1074, code: "YL", name: "Long Island Airlines Ltd" },
{ id: 1075, code: "NJ", name: "Vanguard Airlines Inc" },
{ id: 1076, code: "YM", name: "Blue Sky Carrier" },
{ id: 1077, code: "RG", name: "Varig" },
{ id: 1078, code: "YN", name: "Air Creebec" },
{ id: 1079, code: "VP", name: "Vaspbrazilian Airlines" },
{ id: 1080, code: "YO", name: "Heli Air Monaco" },
{ id: 1081, code: "V4", name: "Venus Airlines" },
{ id: 1082, code: "YP", name: "Aero Lloyd Flugreisen" },
{ id: 1083, code: "VA", name: "Viasa Venezolana" },
{ id: 1084, code: "YQ", name: "Helikopterservice" },
{ id: 1085, code: "VI", name: "Vieques Air Link" },
{ id: 1086, code: "YR", name: "Scenic Airlines" },
{ id: 1087, code: "VN", name: "Vietnam Airlines" },
{ id: 1088, code: "YS", name: "Proteus" },
{ id: 1089, code: "9V", name: "VIP Air" },
{ id: 1090, code: "YT", name: "Skywest Airlines" },
{ id: 1091, code: "VS", name: "Virgin Atlantic" },
{ id: 1092, code: "YU", name: "Aerolineas Dominicanas" },
{ id: 1093, code: "BQ", name: "Virgin Express" },
{ id: 1094, code: "YV", name: "Mesa Airlines" },
{ id: 1095, code: "S5", name: "Virgin Islands Airways" },
{ id: 1096, code: "YW", name: "Air Nostrum" },
{ id: 1097, code: "5V", name: "Vistajet" },
{ id: 1098, code: "YX", name: "Midwest Express Airlines" },
{ id: 1099, code: "VG", name: "VLM Vlaamse" },
{ id: 1100, code: "YZ", name: "Trans Aer Guine Bissau" },
{ id: 1101, code: "Z3", name: "Promech" },
{ id: 1102, code: "Z4", name: "Tayfunair Inc" },
{ id: 1103, code: "Z5", name: "Newwest Airlines Inc" },
{ id: 1104, code: "Z6", name: "Dnieproavia State" },
{ id: 1105, code: "Z7", name: "Zimbabwe Express Air" },
{ id: 1106, code: "Z8", name: "Pulkovo Airlines" },
{ id: 1107, code: "Z9", name: "Aero Zambia" },
{ id: 1108, code: "ZA", name: "ZAS Airline of Egypt" },
{ id: 1109, code: "ZB", name: "Monarch Airlines" },
{ id: 1110, code: "ZC", name: "Royal Swazi National Air" },
{ id: 1111, code: "ZE", name: "Cosmos Air" },
{ id: 1112, code: "ZF", name: "Airborne of Sweden AB" },
{ id: 1113, code: "ZG", name: "Sabair Airlines" },
{ id: 1114, code: "ZH", name: "Air Truck" },
{ id: 1115, code: "ZI", name: "Aigle Azur" },
{ id: 1116, code: "ZJ", name: "Teddy Air" },
{ id: 1117, code: "ZK", name: "Great Lakes Aviation Ltd" },
{ id: 1118, code: "ZL", name: "Hazelton Airlines" },
{ id: 1119, code: "ZM", name: "Scibe Airlift" },
{ id: 1120, code: "ZN", name: "Eagle Airlines" },
{ id: 1121, code: "ZP", name: "Air St Thomas" },
{ id: 1122, code: "ZQ", name: "Ansett New Zealand" },
{ id: 1123, code: "ZR", name: "MUK Air" },
{ id: 1124, code: "ZS", name: "Azzurra Air Spa" },
{ id: 1125, code: "ZT", name: "Air Zambezi" },
{ id: 1126, code: "ZU", name: "Freedom Air" },
{ id: 1127, code: "ZV", name: "Air Midwest" },
{ id: 1128, code: "ZW", name: "Air Wisconsin Airlines" },
{ id: 1129, code: "ZX", name: "Air B C" },
{ id: 1130, code: "ZY", name: "ADA Air" },
{ id: 1131, code: "ZZ", name: "Buzz" },
{ id: 1132, code: "P4", name: "Air Peace" },
{ id: 1133, code: "PA", name: "Air Blue" },
{ id: 1134, code: "UR", name: "Uganda Airline" },


];

export default AirlineCode;
